import React from 'react'
import classes from './Loading.module.scss'

// based on https://codepen.io/keefyboooo/pen/BNzdEg
export function Loading() {
  return (
    <div className={classes['loader-icon']}/>
  )
}
